export const ACCOUNT_DELETED_AUTH_MESSAGE_KEY =
  "account_deleted_auth_message";

const DELETED_ACCOUNT_DETAILS = new Set([
  "account_deleted",
  "deleted_account",
  "deleted_account_protection",
  "tombstoned_account",
]);

export function isDeletedAccountAuthError(detail) {
  const normalized = String(detail || "")
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
  return DELETED_ACCOUNT_DETAILS.has(normalized);
}

export function getDeletedAccountAuthMessage(t) {
  return t(ACCOUNT_DELETED_AUTH_MESSAGE_KEY);
}
